import {COST_CENTER_PATTERN, INTENDED_USE_MAX_LENGTH, LIMITS} from './vmware-vm.config'

const PREFIX = 'components.requests.vmware'

export function intendedUseRules(value, t) {
  return [
    {
      satisfied: (value ?? '').length <= INTENDED_USE_MAX_LENGTH,
      message: () => t(`${PREFIX}.intended_use.error_max`, { limit: INTENDED_USE_MAX_LENGTH }),
    },
  ]
}
export function otherOsRules(value, t) {
  return [
    {
      satisfied: (value ?? '').length > 0,
      message: () => t(`${PREFIX}.other_os.error_required`),
    },
  ]
}
function evenNumberRules(value, { max, min, key }, t) {
  const n = Number(value)
  return [
    { satisfied: n <= max, message: () => t(`${PREFIX}.${key}.error_max`, { max }) },
    { satisfied: n >= min, message: () => t(`${PREFIX}.${key}.error_min`, { min }) },
    { satisfied: n === 1 || n % 2 === 0, message: () => t(`${PREFIX}.${key}.error_mod_2`) },
  ]
}

export const cpuRules = (value, os, t) =>
  evenNumberRules(value, { max: LIMITS.cpu.max, min: LIMITS.cpu.minByOs[os], key: 'cpu_cores' }, t)

export const ramRules = (value, os, t) =>
  evenNumberRules(value, { max: LIMITS.ram.max, min: LIMITS.ram.minByOs[os], key: 'ram_gb' }, t)

export function diskRules(value, os, t) {
  const n = Number(value)
  const min = LIMITS.disk.minByOs[os]
  return [
    { satisfied: n >= min, message: () => t(`${PREFIX}.disk_gb.error_min`, { min }) },
    { satisfied: Number.isInteger(n), message: () => t(`${PREFIX}.disk_gb.error_int`) },
  ]
}
export function costCenterRules(value, t) {
  return [
    {
      satisfied: COST_CENTER_PATTERN.test((value ?? '').replaceAll('.', '')),
      message: () => t(`${PREFIX}.cost_center.error_pattern`),
    },
  ]
}
export function sshKeysRules(value, t) {
  return [
    {
      satisfied: (value ?? '').trim().length > 0,
      message: () => t(`${PREFIX}.ssh_keys.error_required`),
    },
  ]
}
